import { getDemoData, matchRestRequest } from '../utils'

export const mockGetRosters = {
  shouldMock: (request) =>
    matchRestRequest(
      request,
      '/company/graphql_dispatch/rosters_query_557f8228',
      'POST'
    ),
  getResponse: async () => {
    const demoData = getDemoData()

    return {
      data: {
        company: {
          rosters: demoData.rosters,
        },
      },
    }
  },
}
